import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './TaskStatsWidget.scss';

const TaskStatsWidget = ({ assignedBy, assignedTo }) => {
  const [activeTab, setActiveTab] = useState('assignedTo');
  const [animateStats, setAnimateStats] = useState(false);

  const COLORS = ['#10b981', '#E35151'];

  useEffect(() => {
    setAnimateStats(true);
    const timer = setTimeout(() => setAnimateStats(false), 600);
    return () => clearTimeout(timer);
  }, [activeTab]);

  const getCurrentData = () => {
    const source = activeTab === 'assignedTo' ? assignedTo : assignedBy;
    return [
      { name: 'Completed', value: source?.completedTasks || 0 },
      // { name: 'In Progress', value: source?.inProgressTasks || 0 },
      { name: 'Pending', value: source?.pendingTasks || 0 },
      // { name: 'Due Today', value: source?.dueTodayCount || 0 },
    ];
  };

  const getCurrentStats = () => {
    return activeTab === 'assignedTo' ? assignedTo : assignedBy;
  };

  const data = getCurrentData();
  const stats = getCurrentStats();

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="stat-tooltip-label">{`${payload[0].name}: ${payload[0].value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="task-stats-widget">
      <div className="widget-header">
        {/* <h2 className="widget-title">Task Analytics</h2> */}
        <div className="tab-container">
          <button
            className={`tab-button ${activeTab === 'assignedTo' ? 'active' : ''}`}
            onClick={() => setActiveTab('assignedTo')}
          >
            <span className="tab-icon"></span>
            Assigned To Me
          </button>
          <button
            className={`tab-button ${activeTab === 'assignedBy' ? 'active' : ''}`}
            onClick={() => setActiveTab('assignedBy')}
          >
            <span className="tab-icon"></span>
            Assigned By Me
          </button>
        </div>
      </div>

      <div className="widget-content">
        <div className="chart-container">
          {/* <h3 className="chart-title">Task Distribution Overview</h3> */}
          <div className="total-tasks">
            <span className="total-label">Total Tasks:</span>
            <span className="total-number">{stats?.totalTasks || 0}</span>
          </div>
          <ResponsiveContainer width="100%" height={350}>
            <PieChart>
              <Pie
                dataKey="value"
                data={data}
                cx="50%"
                cy="50%"
                outerRadius={110}
                innerRadius={50}
                paddingAngle={3}
                animationBegin={0}
                animationDuration={1000}
              >
                {data.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={COLORS[index % COLORS.length]}
                    stroke="#fff"
                    strokeWidth={2}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                verticalAlign="bottom" 
                height={50}
                iconType="circle"
                wrapperStyle={{
                  paddingTop: '20px',
                  fontSize: '14px'
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default TaskStatsWidget;